<template>
  <div class="container-fluid">
    <table class="xz-table">
      <tbody>
      <tr>
        <td class="xz-various-counters-label">Kasseskuffåpninger:</td>
        <td colSpan="2">{{xReportCounters.cashBoxOpeningsCount}}x</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Salgskvitteringer:</td>
        <td colSpan="2">{{xReportCounters.saleReceiptsCount}}x</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Kopikvitteringer:</td>
        <td class="xz-various-counters-width">{{ xReportCounters.copyReceiptsCount }}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(xReportCounters.copyReceiptsTotalAmount) }}</td>
      </tr>
      <!-- How many returns there were, as «Salgskvitteringer» is how many sales: «Total refusjon» counts the payments
           paid back (founder, 2026-10-29). -->
      <tr>
        <td class="xz-various-counters-label">Returkvitteringer:</td>
        <td class="xz-various-counters-width">{{ xReportCounters.refundReceiptsCount || 0 }}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(xReportCounters.refundReceiptsTotalAmount || 0) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Rabatter:</td>
        <td class="xz-various-counters-width">{{ xReportCounters.discountsCount }}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(xReportCounters.discountsTotalAmount) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Avbrutte salg:</td>
        <td class="xz-various-counters-width">{{xReportCounters.uncompletedSalesCount}}x</td>
        <td class="xz-various-counters-width">{{ displayTwoDecimals(xReportCounters.uncompletedSalesTotalAmount) }}</td>
      </tr>
      </tbody>
    </table>
    <hr class="horizontal-dashed"/>
    <table class="xz-table">
      <tbody>
      <tr>
        <td class="xz-various-counters-label">Grand total salg:</td>
        <td colSpan="2">{{ displayTwoDecimals(xReportCounters.grandTotalSales) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Grand total retur:</td>
        <td colSpan="2">{{ displayTwoDecimals(xReportCounters.grandTotalRefund) }}</td>
      </tr>
      <tr>
        <td class="xz-various-counters-label">Grand total netto:</td>
        <td colSpan="2">{{ displayTwoDecimals(grandTotalNet) }}</td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
  import MathUtil from "@/util/MathUtil";

  export default {
    props: {
      xReportCounters: Object
    },
    computed: {
      grandTotalNet() {
        return (this.xReportCounters.grandTotalSales - this.xReportCounters.grandTotalRefund);
      }
    },
    methods: {
      displayTwoDecimals(num){
        if(num > 0 || num < 0){
          return MathUtil.displayTwoDecimals(num);
        }else {
          return num;
        }
      }
    }
  }
</script>
